import React from 'react';
import PropTypes from 'prop-types';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import Books from 'shared/img/education-onboarding/books.svg';
import styles from '../Resume/styles.module.scss';

const propTypes = {
  student: PropTypes.shape({
    firstName: PropTypes.string,
  }),
};

const GettingStarted = ({student: {firstName}}) => (
  <BaseStep
    stepHeader={
      <>
        <Books className={styles.icon} width={116} />
        Hi{firstName ? `, ${firstName}` : ' there'}!
      </>
    }
    subHeader={
      <>
        Ready to make the best of your time in college?
        <br />
        Let&apos;s get you started.
      </>
    }
  />
);

GettingStarted.propTypes = propTypes;

export default GettingStarted;
